<template>
  <div class="safety-stocks-info-btn">
    <el-badge :is-dot="danger">
      <el-button
        type="primary"
        @click="getsafetystocks">
        安全库存信息
      </el-button>
    </el-badge>
    <safety-stocks-info-modal ref="info" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SafetyStocksInfoModal from './safety-stocks-info-modal.vue'
export default {
  name: 'SafetyStocksInfoBtn',
  components: { SafetyStocksInfoModal },
  data() {
    return {
      danger: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    getsafetystocks() {
      this.$refs.info.fetch()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('product/getsafetystocks', {
        payload: {
          pageNum: 1,
          pageSize: 1,
          productId: null,
          productType: null
        },
        success: res => {
          this.loading = false
          this.danger = res.data.records.length > 0
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus">
.safety-stocks-info-btn {
 .el-badge__content.is-dot {
   width: 12px;
   height: 12px
 }
}

</style>
